import React, { useEffect, useState } from 'react'
import { fetchFaqApi } from '../../../services/faqs';
import { Accordion } from "react-bootstrap";
import { FaCaretDown } from "react-icons/fa";

const NewFaqHome = () => {
    const [faqList, setFaqList] = useState([])
    const [loader, setLoader] = useState(false)
    const [visibleCount, setVisibleCount] = useState(5);
    // const showMore = () => setVisibleCount((prev) => prev + 5);
    // const reset = () => setVisibleCount((5));
    const showMore = () => {
        // Increase count but cap it at the total length
        setVisibleCount((prev) => Math.min(prev + 5, faqList.length));
    };

    const reset = () => {
        // Reset back to 5 or less if list has fewer items
        setVisibleCount(Math.min(5, faqList.length));
    };
    // -----------listing-----------------
    useEffect(() => {
        const fetchFaq = async () => {
            try {
                setLoader(true)
                const { data } = await fetchFaqApi({
                    limit: 5,
                    page: 1,
                    Pagination: true,
                });
                const { data: faq, success, message } = data;
                if (success) {
                    setFaqList(faq || [])
                }
            } catch (e) {
                console.log("Login:-", e.message);
            } finally {
                setLoader(false);
            }
        };
        fetchFaq();
    }, []);
    return (
        <div className="faq_wrapper" >
            <Accordion defaultActiveKey="0">
                {/* {ratings?.slice(0, visibleCount).map((ele, index) => { */}
                {faqList && faqList.length > 0 ? faqList.slice(0, visibleCount).map((data, ind) => (
                    <Accordion.Item eventKey={String(ind)} key={data._id || ind}>
                        <Accordion.Header>{data?.title}</Accordion.Header>
                        <Accordion.Body>{data?.description || "N/A"}</Accordion.Body>
                    </Accordion.Item>
                )) : null}

                {faqList.length > 5 && (
                    <div className='text-center fs-5 mt-4'>
                        {visibleCount < faqList.length ? (
                            <button className='text-white' onClick={showMore}>View More</button>
                        ) : (
                            <button className='text-white' onClick={reset}>Reset</button>
                        )}
                    </div>
                )}

            </Accordion>
        </div>
    )
}

export default NewFaqHome